import { useApplicationContext } from '~/shared/context/use-application-context';
import { useHasRole } from '~/shared/context/use-has-role';

export const useCanSeeSkillReferences = (): boolean => {
    const { applicationState } = useApplicationContext();
    const isJobArchitect = useHasRole('job_architect');

    return isJobArchitect && applicationState.featureFlagService.isFeatureFlagEnabled('show-skill-stats-in-detail');
};
